
if (!customElements.get("bundle-configurator")) {
  class BundleConfigurator extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
      }

      this.steps = this.querySelectorAll(".bundle-configurator__step");
      this.bundleSize = this.steps.length;
      this.bundleItems = this.querySelectorAll("bundle-item");

      this.bundleProducts = []

      this.addToCartButton = this.querySelector(".bundle-add-to-cart");
      
      this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    }

    connectedCallback() {
      this.toggleState = false;
      if (!this.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
      this.querySelector(".button--close").addEventListener("click", this.close.bind(this));
      this.querySelector(".bundle-configurator-drawer__backdrop").addEventListener("click", this.close.bind(this));
      document.querySelectorAll("[bundle-configurator-trigger]").forEach(element => {
        element.addEventListener("click", this.open.bind(this));
      });

      this.bundleItems.forEach(item => {
        item.addEventListener("click", (event) => {
          const bundleItem = event.target.closest('bundle-item');
          this.selectItem(bundleItem);
        }, );
      });

      this.addToCartButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      this.classList.add("is--open");
    }

    close() {
      this.toggleState = false;
      document.querySelector("body").classList.remove("overflow-hidden");
      this.classList.remove("is--open");
      this.toggleAriaExpanded();
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target.closest("button").setAttribute("aria-expanded", true);
        this.querySelector(".button--close").setAttribute("aria-expanded", true);
      } else {
        document
          .querySelectorAll('[aria-controls="bundle-configurator-drawer"]')
          .forEach(button => {
            button.setAttribute("aria-expanded", false);
          });
      }
    }

    selectItem(target) {
      const stepSelection = target.closest(".bundle-configurator__step");
      const stepIndex = stepSelection.dataset.step;

      stepSelection.querySelectorAll("bundle-item").forEach(item => item.classList.remove("is-selected"));
      target.classList.add("is-selected");
      
      target.closest(".bundle-configurator__step").querySelector(".bundle-configurator__step-sizes").classList.add("bundle-configurator__step-sizes--animate");
      setTimeout(() => {
        target.closest(".bundle-configurator__step").querySelector(".bundle-configurator__step-sizes").classList.remove("bundle-configurator__step-sizes--animate");
      }, 300);

      this.updateSizes(target)
    }

    updateSizes(target) {
      const currentStep = target.closest(".bundle-configurator__step")
      const currentStepIndex = Number(currentStep.dataset.step) - 1
      const currentStepSizes = currentStep.querySelector(".bundle-configurator__step-sizes__values");
      const sizesObj = target.dataset.sizes.split(':::').map(size => {
        const [sizeName, sizeValue, sizeAvailable] = size.split(':');
        return { name: sizeName, value: sizeValue, isAvailable: sizeAvailable === 'true' };
      });
      console.log('dd')
      currentStepSizes.innerHTML = sizesObj.map(size => {
        return size.isAvailable ? `
          <input class="product-option__input variant-option-radio-input visually-hidden" type="radio" name="item-size-${currentStepIndex}" value="${size.value}" id="size--${currentStepIndex}--${size.value}" data-size-name="${size.name}">
          <label class="product-option__label product-option__label--circle" data-size="${size.value}" for="size--${currentStepIndex}--${size.value}" aria-label="${size.name}">${size.name}</label>
        ` : `
          <input class="product-option__input variant-option-radio-input visually-hidden" type="radio" name="item-size-${currentStepIndex}" value="${size.value}" id="size--${currentStepIndex}--${size.value}" data-size-name="${size.name}" disabled>
          <label class="product-option__label product-option__label--circle" data-size="${size.value}" for="size--${currentStepIndex}--${size.value}" aria-label="${size.name}" disabled>${size.name}</label>
        `;

      }).join('');

      currentStepSizes.querySelectorAll("input[type='radio']").forEach(input => {
        input.addEventListener("change", (event) => {
          const selectedSize = event.target;
          currentStepSizes.querySelectorAll("input[type='radio']").forEach(input => input.classList.remove('is-selected'));
          this.bundleProducts[currentStepIndex] = {
            variant_id: selectedSize.value,
            size: selectedSize.dataset.sizeName,
            title: target.dataset.title,
            image: target.dataset.image
          };

          this.checkValidity();
          this.updateSelections();
        });
      });
      
      delete this.bundleProducts[currentStepIndex];
      this.checkValidity();
      this.updateSelections();
    }

    updateSelections() {
      this.steps.forEach((step, index) => {
        if (this.bundleProducts[index]) {
          const selectedItem = this.bundleProducts[index];
          step.querySelector(".bundle-configurator__step-selection").innerHTML = `
            <div class="bundle-configurator__step-selection__image">
              <img src="${selectedItem.image}" alt="${selectedItem.title}">
            </div>
            <div class="bundle-configurator__step-selection__desc">
              <p class="bundle-configurator__step-selection__title">${selectedItem.title}</p>
              <p class="bundle-configurator__step-selection__size">${selectedItem.size}</p>
            </div>
          `;
          step.classList.add("is-complete");
          this.stepCompletedAction(step, index, this.bundleSize);
        } else {
          step.querySelector(".bundle-configurator__step-selection").innerHTML = '';
          step.classList.remove("is-complete");
        }
      });
    }

    stepCompletedAction(step, index, bundleSize) {
      const summary = step.querySelector("details summary")
      step.closest("accordion-default").toggleDropdown(summary, true)
      // if (index !== bundleSize - 1) {
      //   console.log(`Open next: ${index + 2}`);
      // }
    }

    checkValidity() {
      const filledSlots = this.bundleProducts.filter(item => item !== undefined && item !== null).length;
      const isComplete = filledSlots === this.bundleSize;
      // console.log("Bundle products:", this.bundleProducts);

      if (isComplete) {
        this.addToCartButton.removeAttribute("disabled");
        this.addToCartButton.classList.remove("is--disabled");
      }
      else {
        this.addToCartButton.setAttribute("disabled", "disabled");
        this.addToCartButton.classList.add("is--disabled");
      }
    }

    addToCart() {
      const bundleUid = Date.now()
      const items = this.bundleProducts.map(item => {
        return {
          id: item.variant_id,
          quantity: 1,
          properties: {
            _bundle_id: `zestaw__${bundleUid}`,
          }
        }
      })

      let formData = { 
          items: [...items],
          sections: this.cart.getSectionsToRender().map(section => section.section),
          sections_url: window.location.pathname
        };

      const snrs_uuid = SR.client.getCurrentClient()._result.uuid
      if (snrs_uuid != undefined) {
        formData.attributes = {
          snrs_uuid
        }
      }


      this.addToCartButton.querySelector(".loading__spinner").classList.remove(
        "hidden"
      );

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("Data:", data);
        if (data.status === 422) {
          throw new Error(data.description);
        }
        
        this.cart.renderContents(data);
        this.close();
      })
      .catch((error) => {
        console.error("Error:", error);
        this.handleErrors(error);

        setTimeout(() => {
          this.close();
        }, 4000);
      })
      .finally(() => {
        this.addToCartButton.querySelector(".loading__spinner").classList.add(
          "hidden"
        );
      });
    }

    handleErrors(error) {
      this.querySelector(".bundle-configurator__errors").classList.remove("hidden");

      setTimeout(() => {
        this.querySelector(".bundle-configurator__errors").classList.add("hidden");
      }, 4000);
    }
  }

  customElements.define("bundle-configurator", BundleConfigurator);
}
